/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillList_action";
import {
  voucherActionId,
  bankAccountActionId,
  paymentModeActionId,
  receiptAccountTypeActionId,
  clientNameActionId,
  toastError,
  sessionExpireMessage,
  tokenInavlidMessage,
  downloadReport,
  toastSuccess,
  BASE_URL
} from "../../../utils/constants";
import DatePicker from 'react-datepicker';
import {
  generate_invoice_action,
  getPerformaInvoiceReceiptList_list_action,
  addAccountReceipt_list_action,
  updateAccountReceipt_list_action,
  accountReceipt_Details_action,
  getReceiptNo_list_action,
  generate_nodue_action,
  generate_taxInvoice_action,
  getSendMailReceiptDetailsUrl_action, preview_receipt_action,
  send_tax_invoice_action
} from "../../../actions/accounts_action/account_receipts_action";
// import Modal from "react-modal"
// import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast, } from "react-toastify";
import moment from "moment";
import Header from "../../../common_components/Header";
import $ from 'jquery'
import { download_no_due_action, download_tax_invoice_action, download_exitPass_action, update_exit_pass_action } from '../../../actions/myOrders_action/myOrders_action';
import { Button, Modal } from "react-bootstrap";
class AccountReceiptsAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isAccordionExpanded: false,
      receiptPreviewModal: false, receiptFilePath: "", taxInvoiceFilePath: "",
      voucherId: "",
      voucherList: "",
      bankAccountId: "",
      bankAccountList: "",
      paymentModeId: "",
      paymentModeList: "",
      AccountTypeID: "",
      Amount: '',
      receiptAccountTypeList: [],
      clientNameId: "",
      clientNameList: [],
      tempClientList: [],
      billTempClientList: [],
      isDisplayClientList: false,
      newClienId: '',
      show: false,
      performaInvoiceRecieptList: [],
      chekedPerformaList: [],
      otherChargesList: [
        {
          AccountTypeID: "",
          Amount: "",
          deleteRowId: 1,
        },
      ],
      token: "",
      currency: "",
      conversionRate: 1,
      bankAmount: "",
      tdsAmount: "",
      exchdiif: "",
      onAccAmt: "",
      crAmount: 0,
      totalAmount: "",
      receiptNo: "",
      receiptDate: "",
      paymentReceivedDate: "",
      instrumentNo: "",
      instrumentDate: "",
      bankName: "",
      branchName: "",
      narration: "",
      Is_add: false,
      Is_update: false,
      ClientId: '',
      ReceiptId: '',
      UserId: '',
      addTaxableAmmount: '',
      addTotalPayableAmmount: '',
      addPendingAmmount: '',
      addReceivedAmmount: '',
      isGenVoucherDisabled: false,
      checkAll: false,
      ledgerList: [],
      subLedgerList: [],

      // Input Errors
      voucherTypeErr: "",
      clientErr: "",
      bankAccountErr: "",
      bankAmountErr: "",
      tdsAmountErr: "",
      pymtModeErr: "",
      otherChargesListErr: "",
      totalsErr: "",
      from: '',
      ReceivedAmount: '',
      newPerformaInvoiceRecieptList: [],
      isEditGenerateVoucher: false,
      onPreview: false,
      account: false,
      ammount: false,
      isDisableProformaInvoice: false,
      totalAmountErr: '',
      dummyArray: [],
      paymentReceivedDate: new Date,
      receiptDate: new Date,
      OrderID: '',
      buttomButtonList: {},
      rptDetailsObj: {},
      LedgerCreditAmountErr: '',
      adminReceipt: false,
      OrderNo: '',
      paidAmount: '',
      piSendShow: false,
      ProformaInvoiceID: '',
      ProformaInvoice_No: '',
      isTaxInvoiceFlag: false
    };

    this.modalClose = this.modalClose.bind(this);
    this.modalShow = this.modalShow.bind(this);
    this.getAccounteReceiptDetails = this.getAccounteReceiptDetails.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
    this.autoFillReceivedAmount = this.autoFillReceivedAmount.bind(this);
    this.getPerformaInvoiceRecieptList = this.getPerformaInvoiceRecieptList.bind(this);
    this.chekedPerformaList = this.chekedPerformaList.bind(this);
  }

  componentDidMount = () => {

    if (JSON.parse(sessionStorage.getItem('UserLoginData')) == null) {
      console.log('log')
      setTimeout(() => {
        this.props.navigate('/login')
      }, 500);
    }

    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ?
          this.props.navigate('/checkList') :
          <></>
      }
    }, 10);

    this.getFillList(voucherActionId, "");
    this.getFillList(bankAccountActionId, "");
    this.getFillList(paymentModeActionId, "");
    this.getFillList(receiptAccountTypeActionId, "");

    this.setState({
      Is_add: this.props.location.state != null && this.props.location.state.Is_add != null ? this.props.location.state.Is_add : '',
      Is_update: this.props.location.state != null && this.props.location.state.Is_update != null ? this.props.location.state.Is_update : '',

      ReceiptId: this.props.location.state != null && this.props.location.state.ReceiptId != null ? this.props.location.state.ReceiptId : '',

      isEditGenerateVoucher: this.props.location.state != null && this.props.location.state.isEditGenerateVoucher != null ? this.props.location.state.isEditGenerateVoucher : '',

      onPreview: this.props.location.state != null && this.props.location.state.onPreview != null ? this.props.location.state.onPreview : '',

      adminReceipt: this.props.location.state != null && this.props.location.state.adminReceipt != null ? this.props.location.state.adminReceipt : false,

      OrderNo: this.props.location.state != null && this.props.location.state.OrderNo != null ? this.props.location.state.OrderNo : '',
    }, () => {

      this.getFillList(clientNameActionId, "", this.state.Is_add ? 1 : 0);
    })

    this.props.location.state != null && this.props.location.state.Is_update && this.getAccounteReceiptDetails()

    this.props.location.state != null && this.props.location.state.onPreview && this.getAccounteReceiptDetails()

    console.log("this props", this.props.location)

    if (this.props.location.state.adminReceipt) {
      this.setState({
        clientNameId: this.props.location.state != null && this.props.location.state.ClientID != null ? this.props.location.state.ClientID : '',
        OrderID: this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : '',
      })
      setTimeout(() => {
        this.getPerformaInvoiceRecieptList()
        this.getReceiptNo(this.props.location.state.ClientID)
      }, 200);
    }

    this.loadscript()
  };

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }

  // Generate Report
  generateNoDue() {
    const { rptDetailsObj } = this.state
    this.setState({ isLoading: true });
    this.props
      .generate_nodue_action(
        rptDetailsObj.OrderID,
        rptDetailsObj.OrderNo,
        rptDetailsObj.CompanyName,
        rptDetailsObj.UserEmail,
        rptDetailsObj.ProformaInvoiceID,
        rptDetailsObj.ProformaInvoice_No
      )
      .then((data) => {
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          toast.success("No Due Generated Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.getAccounteReceiptDetails(); // Fetch the updated list of holidays
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  generateTaxInvoice() {
    const { rptDetailsObj } = this.state
    this.setState({ isLoading: true });
    this.props
      .generate_taxInvoice_action(
        rptDetailsObj.OrderID,
        rptDetailsObj.OrderNo,
        rptDetailsObj.CompanyName,
        rptDetailsObj.UserEmail,
        rptDetailsObj.ProformaInvoiceID,
        rptDetailsObj.ProformaInvoice_No
      )
      .then((data) => {
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          const url = BASE_URL.split("/api")[0];
          const structurePath = data.data.filePath.replace('./', '/');
          const FilePath = `${url}${structurePath}`;
          this.setState({
            isTaxInvoiceFlag: true,
            piSendShow: true, ProformaInvoiceID: rptDetailsObj.ProformaInvoiceID, ProformaInvoice_No: rptDetailsObj.ProformaInvoice_No,
            OrderID: rptDetailsObj.OrderID, taxInvoiceFilePath: FilePath, OrderNo: rptDetailsObj.OrderNo
          }, () => {

            this.openTaxInvoiceModal(
              rptDetailsObj.ProformaInvoiceID,
              rptDetailsObj.ProformaInvoice_No,
              rptDetailsObj.OrderID,
              FilePath,
              rptDetailsObj.OrderNo
            );
          })
          // toast.success("Tax Invoice Generated Successfully", {
          //   position: "top-center",
          //   theme: "colored",
          //   autoClose: 3000,
          //   hideProgressBar: true,
          // });
          // this.getAccounteReceiptDetails(); // Fetch the updated list of holidays
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  sendTaxInvoice() {
    const { ProformaInvoiceID, ProformaInvoice_No, rptDetailsObj } = this.state;
    this.setState({ isLoading: true })
    this.props
      .send_tax_invoice_action(rptDetailsObj.OrderID, rptDetailsObj.OrderNo, rptDetailsObj.CompanyName, rptDetailsObj.UserEmail, ProformaInvoiceID, ProformaInvoice_No)
      .then((data) => {
        if (data.error !== 1) {
          toastSuccess("Tax Invoice Send Successfully!")
          this.setState({ piSendShow: false, isLoading: false })
        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            this.setState({ isLoading: false })
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/login')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            toastError(data.msg);
            this.setState({ isLoading: false, exitSub: false });
          }
        }
      })
      .catch((err) => {
        console.error(err); // Logging the error for debugging
        this.setState({ isLoading: false, exitSub: false });
      });
  }

  openTaxInvoiceModal(ProformaInvoiceID, ProformaInvoice_No, OrderID, filePath, OrderNo) {
    this.setState({
      piSendShow: true, ProformaInvoiceID: ProformaInvoiceID, ProformaInvoice_No: ProformaInvoice_No, OrderID: OrderID, taxInvoiceFilePath: filePath, OrderNo: OrderNo
    })
  }

  updateExitPass() {
    this.setState({ isLoading: true });
    const { rptDetailsObj } = this.state
    this.props
      .update_exit_pass_action(
        rptDetailsObj.OrderID,
        rptDetailsObj.OrderNo,
        rptDetailsObj.CompanyName,
        rptDetailsObj.UserEmail,
        rptDetailsObj.UUID
      )
      .then((data) => {
        console.log(
          "Exit pass generated",
          rptDetailsObj.OrderID,
          rptDetailsObj.OrderNo,
          rptDetailsObj.CompanyName,
          rptDetailsObj.UserEmail,
          rptDetailsObj.UUID
        );
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          toast.success("Exit pass generated Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.getAccounteReceiptDetails(); // Fetch the updated list of holidays
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // Download Report
  downloadNoDue() {
    const { rptDetailsObj } = this.state;
    this.setState({ isLoading: true });
    if (rptDetailsObj.OrderID) {
      const formattedOrderNo = rptDetailsObj.OrderNo.replace(/[\/-]/g, "_");
      this.props
        .download_no_due_action(rptDetailsObj.OrderID, formattedOrderNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (
              downloadData.msg == sessionExpireMessage ||
              downloadData.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: OrderID not found.", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    }
  }
  downloadTaxInvoice() {
    const { rptDetailsObj } = this.state;
    this.setState({ isLoading: true });
    const userId = sessionStorage.getItem("userId")
    if (rptDetailsObj.ProformaInvoiceID) {
      const formattedOrderNo = rptDetailsObj.ProformaInvoice_No.replace(/[\/-]/g, "_");
      this.props
        .download_tax_invoice_action(userId, rptDetailsObj.ProformaInvoiceID, formattedOrderNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (
              downloadData.msg == sessionExpireMessage ||
              downloadData.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: OrderID not found.", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    }
  }
  downloadExitPass() {
    const { rptDetailsObj } = this.state;
    this.setState({ isLoading: true });
    const userId = sessionStorage.getItem("userId")
    if (rptDetailsObj.OrderID) {
      const formattedOrderNo = rptDetailsObj.ProformaInvoice_No.replace(/[\/-]/g, "_");
      this.props
        .download_exitPass_action(userId, rptDetailsObj.OrderID, formattedOrderNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (
              downloadData.msg == sessionExpireMessage ||
              downloadData.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: OrderID not found.", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    }
  }

  // Input Feilds Validation
  inputValidate() {
    const { voucherId, newClienId, clientNameId, bankAccountId, bankAmount, tdsAmount, paymentModeId, isGenVoucherDisabled } = this.state
    console.log("tdsAmount 12345", tdsAmount)
    // if (newClienId != "" && clientNameId != "" && bankAccountId != "" && bankAmount != "") {
    if (voucherId == "" || voucherId == "Select") {
      this.setState({ voucherTypeErr: 'Please Select Voucher Type' })
    }
    // }
    if (clientNameId == "Select" || clientNameId == "") {
      this.setState({ clientErr: 'Please Select Client' })
    }
    if (bankAccountId == "" || bankAccountId == "Select") {
      this.setState({ bankAccountErr: 'Please Select Bank Account' })
    }
    if (bankAmount == "") {
      this.setState({ bankAmountErr: 'Please Enter Bank Amount' })
    }
    if (tdsAmount != null && tdsAmount == "") {
      this.setState({ tdsAmountErr: 'Please Enter Tds amount' })
    }
    if (isGenVoucherDisabled) {
      if (paymentModeId == "" || paymentModeId == "Select") {
        this.setState({ pymtModeErr: 'Please Select Payment Mode' })
      }
    }
  }

  getPerformaInvoiceRecieptList() {
    const { clientNameId, totalAmount, newPerformaInvoiceRecieptList, OrderID, } = this.state
    this.setState({ isLoading: true });
    const ReceiptDetailID = this.props.location.state != null && this.props.location.state.ReceiptDetailID != null ? this.props.location.state.ReceiptDetailID : null
    this.props
      .getPerformaInvoiceReceiptList_list_action(clientNameId, totalAmount, OrderID, ReceiptDetailID)
      .then((data) => {
        if (data.error != 1) {
          // this.props.location.state.Is_update == false ?
          //   this.setState({ performaInvoiceRecieptList: data.data, currency: data.data[0]['Currency'] })
          //   : <></>
          if (data.data != '') {
            data.data.sort((a, b) => a.ProformaInvoiceID + b.ProformaInvoiceID)
            if (this.props.location.state.adminReceipt) {
              data.data.map((item) => {
                item.Is_Check = 1
              })
              this.setState({ performaInvoiceRecieptList: data.data, chekedPerformaList: data.data, currency: data.data[0]['Currency'], paidAmount: data.data[0]['PaidAmount'], })
              this.calculateTotals()
            }

            this.setState({ isLoading: false });
            console.log("PaidAmount-----", data.data)
            if (this.props.location.state.Is_add) {
              this.setState({ performaInvoiceRecieptList: data.data, currency: data.data[0]['Currency'], })

            } else {
              if (!this.props.location.state.adminReceipt) {
                var dummyPerformaList = data.data
                dummyPerformaList.map((data, index) => {
                  newPerformaInvoiceRecieptList.map((item, e) => {
                    if (data.ProformaInvoiceID == item.ProformaInvoiceID) {
                      data.Is_Check = 1
                      data.ReceivedAmount = item.ReceivedAmount
                      // data.Pending = (data.Pending + item.ReceivedAmount)
                    }
                  })

                  this.setState({ performaInvoiceRecieptList: dummyPerformaList, currency: dummyPerformaList[0]['Currency'] })
                  setTimeout(() => {
                    this.chekedPerformaList()
                  }, 100);
                })
              }
            }
          }

        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });

    // localStorage.setItem("userName", userName)
  }

  getAccounteReceiptDetails() {

    const ClientId = this.props.location.state.ClientId
    const ReceiptId = this.props.location.state.ReceiptId
    const UserId = this.props.location.state.UserId

    this.setState({ isLoading: true });
    this.props
      .accountReceipt_Details_action(UserId, ClientId, ReceiptId)
      .then((data) => {
        if (data.error != 1) {
          if (data.data['data'] != '' && data.data['performaInvoice'] != '') {
            this.setState({
              buttomButtonList: {
                isOutstandingZero: data.data['performaInvoice'][0]['isOutstandingZero'],
                isNoDue: data.data['performaInvoice'][0]['isNoDue'],
                FinalExitSubmit: data.data['performaInvoice'][0]['FinalExitSubmit'],
                isExitPass: data.data['performaInvoice'][0]['isExitPass'],
                IsTaxInvoiceGenerated: data.data['performaInvoice'][0]['IsTaxInvoiceGenerated'],
              },
              rptDetailsObj: {
                CompanyName: data.data['data'][0]['CompanyName'],
                UserName: data.data['data'][0]['UserName'],
                UserEmail: data.data['data'][0]['UserEmail'],
                OrderID: data.data['performaInvoice'][0]['OrderID'],
                OrderNo: data.data['performaInvoice'][0]['OrderNo'],
                ProformaInvoiceID: data.data['performaInvoice'][0]['ProformaInvoiceID'],
                ProformaInvoice_No: data.data['performaInvoice'][0]['ProformaInvoice_No'],
                ProformaType: data.data['performaInvoice'][0]['ProformaType'],
                UUID: data.data['performaInvoice'][0]['UUID'],
                receiptFilePath: data.data['data'][0]['receiptFilePath'], taxInvoiceFilePath: data.data['performaInvoice'][0]['taxInvoiceFilePath'],
              },
              isTaxInvoiceFlag: data.data['performaInvoice'][0]['IsTaxInvoiceGenerated']
            })

          }
          this.setState({
            voucherId: data.data['data'][0]['VoucherTypeID'],
            clientNameId: data.data['data'][0]['ClientID'],
            bankAccountId: data.data['data'][0]['BankID'],
            currency: data.data['data'][0]['Currency'] == 'Indian Rupees' ? 'INR' : data.data['data'][0]['Currency'],
            conversionRate: data.data['data'][0]['ConversionRate'],
            bankAmount: data.data['data'][0]['BankAmount'],
            tdsAmount: data.data['data'][0]['TDSAmount'] != null ? parseFloat(data.data['data'][0]['TDSAmount']).toFixed(2) : '',
            exchdiif: data.data['data'][0]['ExchangeDifference'] != null ? parseFloat(data.data['data'][0]['ExchangeDifference']).toFixed(2) : null,
            onAccAmt: data.data['data'][0]['OnAccAmount'],
            crAmount: data.data['data'][0]['CreditAmount'] != null ? parseFloat(data.data['data'][0]['CreditAmount']).toFixed(2) : null,
            totalAmount: data.data['data'][0]['TotalAmount'],
            receiptNo: data.data['data'][0]['ReceiptNo'],
            receiptDate: data.data['data'][0]['ReceiptDate'] != null ? data.data['data'][0]['ReceiptDate'] : '',
            paymentModeId: data.data['data'][0]['PaymentModeID'],
            instrumentNo: data.data['data'][0]['InstrumentNo'],
            instrumentDate: data.data['data'][0]['InstrumentDate'] != null ? moment(data.data['data'][0]['InstrumentDate'], 'YYYY-MM-DD').toDate() : '',
            paymentReceivedDate: data.data['data'][0]['PaymentReceivedDate'] != null ? moment(data.data['data'][0]['PaymentReceivedDate'], 'YYYY-MM-DD').toDate() : '',
            bankName: data.data['data'][0]['BankName'],
            branchName: data.data['data'][0]['BranchName'],
            narration: data.data['data'][0]['Narration'],
            otherChargesList: data.data['otherDetails'] != '' ? data.data['otherDetails'] : this.state.otherChargesList,
            newPerformaInvoiceRecieptList: data.data['performaInvoice'],
            dummyArray: data.data['performaInvoice'],
          });
          console.log("data.data['data'][0]['TDSAmount']", data.data['data'][0])
          console.log("data.data['data'][0]['ReceiptDate']", data.data['data'][0]['ReceiptDate'])
          this.setState({ isLoading: false });

          setTimeout(() => {
            this.getPerformaInvoiceRecieptList()
          }, 100);

          setTimeout(() => {
            this.calculateTotals()
            this.handleTotalAmt()
          }, 200);

          // setTimeout(() => {
          //   this.handleOnAccAmt()

          // }, 500);

          if (data.data['otherDetails'] != '') {
            data.data['otherDetails'].map((data, i) => {
              data.deleteRowId = i++
            })
            console.log("%%%", data.data['otherDetails'])
          }

        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });



    // localStorage.setItem("userName", userName)
  }

  getReceiptNo(id) {
    const { ClientId } = this.state
    this.props
      .getReceiptNo_list_action(id)
      .then((data) => {
        if (data.error != 1) {

          this.setState({
            receiptNo: data.data[0]['ReceiptNo'],
            receiptDate: data.data[0]['ReceiptDate'] != null ? data.data[0]['ReceiptDate'] : '',
          });

        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });



    // localStorage.setItem("userName", userName)
  }

  modalShow() {
    const { newClienId, bankAccountId, bankAmount, tdsAmount, clientNameId } = this.state

    if (clientNameId != '' && bankAccountId != '' && bankAccountId != 'Select' && bankAmount != '') {
      this.setState({
        show: true,
      });
    } else {
      this.inputValidate()
      toastError("Please fill mendetory feilds")
    }

  };

  modalClose = () => {
    this.setState({ show: false })
  }

  getFillList(value, userID, keyword) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(value, userID == "" || userID == null ? null : userID, keyword)
      .then((data) => {
        if (data.error != 1) {
          if (value == voucherActionId) {
            this.setState({ voucherList: data.data, isLoading: false });
          }
          if (value == bankAccountActionId) {
            this.setState({ bankAccountList: data.data, isLoading: false });
          }
          if (value == paymentModeActionId) {
            this.setState({ paymentModeList: data.data, isLoading: false });
          }
          if (value == receiptAccountTypeActionId) {
            this.setState({
              receiptAccountTypeList: data.data,
              isLoading: false,
            });
          }
          if (value == clientNameActionId) {
            this.setState({
              clientNameList: data.data,
              tempClientList: data.data,
              billTempClientList: data.data,
            })
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // search client
  onClientSearch(e) {
    const { clientNameList, tempClientList } = this.state
    if (e.target.value != '') {
      var searchClientList = tempClientList.filter(data => {
        return (
          data
            .Client
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        )
      })
      this.setState({
        clientNameId: e.target.value,
        clientErr: '',
        tempClientList: searchClientList,
        isDisplayClientList: true
      })
    } else {
      this.setState({
        clientNameId: e.target.value,
        tempClientList: clientNameList,
        isDisplayClientList: false
      })
    }
  }

  // render city
  renderClientList() {
    const { tempClientList } = this.state
    return (
      <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
        {
          tempClientList.length > 0 && tempClientList.map(data => (
            <li class="list-group-item" key={Math.random()}
              onClick={() => this.mainClientListData(data)}
            >{data.Client}</li>
          ))
        }
      </ul>
    )
  }

  mainClientListData(data) {

    this.setState({ clientNameId: data.Client, newClienId: data.ClientID, isDisplayClientList: false, clientErr: '' })
    setTimeout(() => {
      this.getPerformaInvoiceRecieptList()
      this.setState({ chekedPerformaList: [], checkAll: false })
    }, 100);
  }

  onClientSelect(e) {
    const event = e.target.value
    if (event != '' && event != 'Select') {
      this.setState({ clientNameId: e.target.value, isDisplayClientList: false, clientErr: '', dummyArray: [] })
      setTimeout(() => {
        this.getPerformaInvoiceRecieptList()
        this.getReceiptNo(e.target.value)
        this.setState({ chekedPerformaList: [], checkAll: false })
      }, 100);
    } else {
      this.setState({ clientNameId: '', isDisplayClientList: false, clientErr: '' })
    }
  }

  chekedPerformaList() {
    const { performaInvoiceRecieptList, chekedPerformaList } = this.state;
    const List = []
    performaInvoiceRecieptList.map((data) => {
      if (data.Is_Check == 1) {
        List.push(data)
      }
    })
    this.setState({ chekedPerformaList: List, paidAmount: List[0]['PaidAmount'] })
  }

  tableBodyCheckbox(index, orderId, e) {
    const { performaInvoiceRecieptList, dummyArray, chekedPerformaList } = this.state;
    const pList = [...performaInvoiceRecieptList];
    const event = e.target.checked;
    // console.log("event", event);
    if (event == true) {
      pList.forEach((data, i) => {
        if (i === index) {
          dummyArray.push(data)
          console.log("dummyArray-------", dummyArray)
          if (dummyArray.length > 0) {
            if (dummyArray[0]['OrderID'] == data.OrderID) {
              data.Is_Check = 1
            } else {
              data.Is_Check = 0
              var filter = dummyArray.filter(item => data.ProformaInvoiceID != item.ProformaInvoiceID)
              this.setState({ dummyArray: filter })
              toastError("Multiple proforma can be selected which is same application number.")
            }
          }
        }
      });
    } else {
      pList.forEach((data, i) => {
        if (i === index) {
          var filter = dummyArray.filter(item => data.ProformaInvoiceID != item.ProformaInvoiceID)
          this.setState({ dummyArray: filter })
          data.Is_Check = 0;
        }
      });
    }
    this.setState({
      performaInvoiceRecieptList: pList,
    });
    // console.log("XXXXXXXX Is_Check == 0 XXXXXXX", pList);

    const AllSelected = pList.every(item => item.Is_Check == 1)
    if (AllSelected) {
      this.setState({ checkAll: true })
    } else {
      this.setState({ checkAll: false })
    }


  }

  tableHeadCheckbox(e) {
    const { performaInvoiceRecieptList } = this.state;
    const pList = [...performaInvoiceRecieptList];
    if (e.target.checked == true) {
      pList.forEach((data, i) => {
        data.Is_Check = 1;
        this.setState({
          performaInvoiceRecieptList: pList,
          checkAll: true
        });
      });
    } else {
      pList.forEach((data, i) => {
        data.Is_Check = 0;
        this.setState({
          performaInvoiceRecieptList: pList,
          checkAll: false
        });
      });
    }

  }

  //handle Bank Amount
  handleBankAmount(e) {
    this.setState({ bankAmount: e.target.value != '' ? parseFloat(e.target.value).toFixed(2) : '' })
    this.handleTotalAmt()
    const { totalCurrPend } = this.calculateTotals()
    setTimeout(() => {
      if (totalCurrPend != 0) {
        this.handleOnAccAmt()
      }
    }, 300);
    setTimeout(() => {
      this.autoFillReceivedAmount()
    }, 500);
  }

  // handle On Acc Amt 
  handleOnAccAmt() {
    const { totalAmount, onAccAmt } = this.state
    const { totalCurrPend } = this.calculateTotals()
    const CalOnAccAmt = parseFloat(totalAmount) - parseFloat(totalCurrPend)
    if (CalOnAccAmt >= 0) {
      this.setState({ onAccAmt: CalOnAccAmt.toFixed(2) }, () => {
      })
    } else {
      this.setState({ onAccAmt: 0.00 })
    }
  }

  // auto fill received amount
  autoFillReceivedAmount() {
    const { totalAmount, chekedPerformaList } = this.state

    var balanceAmount = parseFloat(totalAmount)
    var sumOfAmount = 0
    var Flag = true

    chekedPerformaList.map((data, i) => {
      if (i == 0) {
        if (parseFloat(totalAmount) >= parseFloat(data.Pending + data.PaidAmount)) {
          data.ReceivedAmount = parseFloat(data.Pending + data.PaidAmount)
          balanceAmount = balanceAmount - parseFloat(data.Pending + data.PaidAmount)
          sumOfAmount += data.ReceivedAmount
        } else {
          data.ReceivedAmount = balanceAmount
          Flag = false
        }
      } else {
        if (balanceAmount >= parseFloat(data.Pending + data.PaidAmount)) {
          data.ReceivedAmount = parseFloat(data.Pending + data.PaidAmount)
          balanceAmount = balanceAmount - parseFloat(data.Pending + data.PaidAmount)
          sumOfAmount += data.ReceivedAmount
        } else {
          if (Flag) {
            data.ReceivedAmount = parseFloat(totalAmount) - sumOfAmount
            Flag = false
          } else {
            data.ReceivedAmount = ''
          }
        }
      }
    })
    this.setState({ chekedPerformaList: chekedPerformaList })
  }

  // handle tds Amount
  handletdsAmount(e) {
    this.setState({ tdsAmount: e.target.value != '' ? parseFloat(e.target.value).toFixed(2) : '', tdsAmountErr: "" })
    this.handleTotalAmt()
    const { totalCurrPend } = this.calculateTotals()
    setTimeout(() => {
      if (totalCurrPend != 0) {
        this.handleOnAccAmt()
      }
    }, 500);
  }

  handleTotalAmt() {
    const { bankAmount, tdsAmount } = this.state
    var bankAmt = bankAmount != "" ? bankAmount : "0"
    var tdsAmt = tdsAmount != "" ? tdsAmount : "0"
    if (bankAmt != "" && tdsAmt != "") {

      const totalCal = parseFloat(bankAmt) + parseFloat(tdsAmt)
      this.setState({ totalAmount: totalCal != '' ? totalCal.toFixed(2) : '', isTotalAmountAvailable: totalCal > 0 ? true : false }, () => {
      })
    } else {
      this.setState({ totalAmount: "", isTotalAmountAvailable: false })

    }
  }

  addOtherCharges(i) {
    const { otherChargesList } = this.state;
    const checkedBlank = otherChargesList.every(item => item.AccountTypeID != '' && item.Amount != "")
    if (checkedBlank) {
      var obj = {
        AccountTypeID: "",
        Amount: "",
        deleteRowId: i++,
      };
      otherChargesList.push(obj);
      this.setState({
        otherChargesList: otherChargesList,
      });
    }
  }

  deleteOtherCharges(deleteRowId) {
    const { otherChargesList } = this.state;
    var list = otherChargesList.filter(
      (data) => data.deleteRowId != deleteRowId
    );

    this.setState({
      otherChargesList: list,
    });
  }

  addAccountReceiptList() {
    const {
      UserId, voucherId, clientNameId, bankAccountId, currency, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receiptNo, receiptDate, paymentModeId, paymentReceivedDate, instrumentNo, instrumentDate, bankName, branchName, narration, performaInvoiceRecieptList, otherChargesList, voucherTypeErr, LedgerCreditAmountErr,
      clientErr,
      bankAccountErr,
      bankAmountErr,
      tdsAmountErr, OrderNo,
      isGenVoucherDisabled, OrderID, ledgerList
    } = this.state;

    const ClientID = this.props.location.state != null && this.props.location.state.ClientID != null ? this.props.location.state.ClientID : ''
    const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''

    const { totalReceivedAmt } = this.calculateTotals()

    const performaArray = [];
    performaInvoiceRecieptList.map((data, i) => {
      if (data.Is_Check == 1) {
        performaArray.push(
          {
            'ProformaID': data.ProformaInvoiceID,
            'ReceivedAmount': data.ReceivedAmount,
          }
        );
      }
    });

    const otherChargesArray = []
    otherChargesList.map((data, i) => {
      if (data.AccountTypeID != '' && data.AccountTypeID != 'Select' && data.Amount != '') {
        otherChargesArray.push(
          {
            'AccountTypeID': data.AccountTypeID,
            'Amount': data.Amount
          }
        )
      }
    })

    const ledgerArray = []
    ledgerList.map((data, i) => {
      ledgerArray.push(
        {
          'Accounts': data.Account,
          'Credit': data.Credit,
          'Debit': data.Debit
        }
      )
    })

    var receiveAccAmount = (parseFloat(onAccAmt != '' ? onAccAmt : 0) + parseFloat(totalReceivedAmt != '' ? totalReceivedAmt : 0))

    this.inputValidate()
    if (voucherId != "" && clientNameId != "" && bankAccountId != "" && bankAmount != "") {
      if (voucherTypeErr == "" && clientErr == "" && bankAccountErr == "" && bankAmountErr == "") {
        if (performaArray.length > 0) {

          if (isGenVoucherDisabled) {
            if (receiveAccAmount == totalAmount) {
              if (paymentModeId != "" && paymentModeId != "Select") {
                if (LedgerCreditAmountErr == '') {
                  this.props
                    .addAccountReceipt_list_action(
                      parseInt(voucherId), clientNameId, parseInt(bankAccountId), currency != '' ? 1 : null, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receiptNo, receiptDate, parseInt(paymentModeId), paymentReceivedDate, instrumentNo, instrumentDate, bankName, branchName, narration, performaArray, otherChargesArray,
                      ledgerArray, OrderNo
                    )
                    .then((data) => {
                      if (data.error != 1) {
                        console.log("success----------")
                        if (this.props.location.state.adminReceipt) {
                          this.props.navigate("/ordersEdit", { state: { OrderID: OrderID, ClientID: ClientID, CenterID: CenterID } })
                        } else {
                          this.props.navigate("/accountReceiptsList");
                        }
                        this.setState({ isLoading: false });
                      } else {
                        if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                          //after session expire.....................
                          sessionStorage.clear()
                          this.props.navigate('/normalView')
                          setTimeout(() => {
                            toast.error(data.msg, {
                              position: "top-center",
                              theme: "colored",
                              autoClose: 3000,
                              hideProgressBar: true,
                            });
                          }, 500);
                        } else {
                          this.setState({ isLoading: false });
                          toast.error(data.data, {
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                          });
                        }


                      }
                    })
                    .catch((e) => {
                      console.log(e);
                    });
                } else {
                  toastError("Total Credit amount must match the total Receipt amount")
                }
              } else {
                toastError("Please Select payment Mode")
              }
            } else {
              toastError("Total Amounts Not Matched")
            }
          }
          else {
            toastError("Please Generate Voucher")
          }
        } else {
          toastError("Please Select Invoices")
        }
      } else {
        toastError("Please Fill Mandatory Fields")
      }
    } else {
      toastError("Please Fill Mandatory Fields")
    }

  }

  updateAccountReceiptList() {
    const {
      UserId, voucherId, clientNameId, bankAccountId, currency, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receiptNo, receiptDate, paymentModeId, paymentReceivedDate, instrumentNo, instrumentDate, bankName, branchName, narration, performaInvoiceRecieptList, otherChargesList, voucherTypeErr, isEditGenerateVoucher,
      clientErr, ledgerList, LedgerCreditAmountErr,
      bankAccountErr,
      bankAmountErr, rptDetailsObj,
      isGenVoucherDisabled
    } = this.state;

    const ReceiptId = this.props.location.state.ReceiptId

    const { totalReceivedAmt } = this.calculateTotals()

    const performaArray = [];
    performaInvoiceRecieptList.map((data, i) => {
      if (data.Is_Check == 1) {
        performaArray.push(
          {
            'ProformaID': data.ProformaInvoiceID,
            'ReceivedAmount': data.ReceivedAmount,
          }
        );
      }
    });

    const otherChargesArray = []
    otherChargesList.map((data, i) => {
      if (data.AccountTypeID != '' && data.AccountTypeID != 'Select' && data.Amount != '') {
        otherChargesArray.push(
          {
            'AccountTypeID': data.AccountTypeID,
            'Amount': data.Amount
          }
        )
      }
    })

    const ledgerArray = []
    ledgerList.map((data, i) => {
      ledgerArray.push(
        {
          'Accounts': data.Account,
          'Credit': data.Credit,
          'Debit': data.Debit
        }
      )
    })

    this.setState({ isLoading: true });
    var receiveAccAmount = (parseFloat(onAccAmt != '' ? onAccAmt : 0) + parseFloat(totalReceivedAmt != '' ? totalReceivedAmt : 0))

    this.inputValidate()
    if (voucherId !== "" && clientNameId !== "" && bankAccountId !== "" && bankAmount !== "") {
      if (performaArray.length > 0) {

        if (isGenVoucherDisabled && !isEditGenerateVoucher) {
          if (receiveAccAmount == totalAmount) {
            if (paymentModeId != "" && paymentModeId != "Select") {
              if (LedgerCreditAmountErr == '') {
                this.props
                  .updateAccountReceipt_list_action(
                    UserId, ReceiptId, parseInt(voucherId), clientNameId, parseInt(bankAccountId), currency != '' ? 1 : null, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receiptNo, receiptDate, parseInt(paymentModeId), paymentReceivedDate, instrumentNo, instrumentDate, bankName, branchName, narration, performaArray, otherChargesArray, ledgerArray, rptDetailsObj.OrderNo
                  )
                  .then((data) => {
                    if (data.error != 1) {
                      this.props.navigate("/accountReceiptsList");
                      this.setState({ isLoading: false });
                    } else {
                      if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.setState({ isLoading: false });
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                          toast.error(data.msg, {
                            position: "top-center",
                            theme: "colored",
                            autoClose: 3000,
                            hideProgressBar: true,
                          });
                        }, 500);
                      } else {
                        this.setState({ isLoading: false });
                        toast.error(data.data, {
                          theme: "colored",
                          autoClose: 3000,
                          hideProgressBar: true,
                        });
                      }
                    }
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              } else {
                toastError("Total Credit amount must match the total Receipt amount")
                this.setState({ isLoading: false });
              }
            } else {
              toastError("Please Select payment Mode")
              this.setState({ isLoading: false });
            }
          } else {
            toastError("Total Amounts Not Matched")
            this.setState({ isLoading: false });
          }
        }
        else {
          toastError("Please Generate Voucher")
          this.setState({ isLoading: false });
        }
      } else {
        toastError("Please Select Invoices")
        this.setState({ isLoading: false });
      }

    } else {
      toastError("Please Fill Mandatory Fields")
      this.setState({ isLoading: false });
    }
  }
  previewReceipt() {
    const { receiptNo } = this.state;
    const ReceiptId = this.props.location.state.ReceiptId
    this.setState({ isLoading: true });
    console.log('con 1')
    this.props
      .preview_receipt_action(ReceiptId, receiptNo)
      .then((data) => {
        if (data.error != 1) {
          const url = BASE_URL.split("/api")[0];
          const structurePath = data.data.filePath.replace('./', '/');
          const FilePath = `${url}${structurePath}`;
          this.setState({ isLoading: false, receiptPreviewModal: true, receiptFilePath: FilePath });
        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.setState({ isLoading: false });
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  onSendMailReceipt() {
    const { bankAmount, tdsAmount, rptDetailsObj } = this.state;
    const ReceiptId = this.props.location.state.ReceiptId
    this.setState({ isLoading: true });
    this.props
      .getSendMailReceiptDetailsUrl_action(ReceiptId, rptDetailsObj.OrderNo, bankAmount, tdsAmount)
      .then((data) => {
        if (data.error != 1) {
          // this.props.navigate("/accountReceiptsList");
          toastSuccess("Receipt Send Successfully")
          this.setState({ isLoading: false });
        } else {
          if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.setState({ isLoading: false });
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  otherChargesReceiptAmount(e, index) {
    const { otherChargesList } = this.state
    const list = [...otherChargesList]
    for (let i = 0; i < list.length; i++) {
      if (i == index) {
        list[i]['Amount'] = e.target.value.replace(/\D/, '')

      }
    }
    this.setState({
      otherChargesList: list
    })
  }

  otherChargesReceiptAccountTypeId(e, index) {

    const { otherChargesList } = this.state
    const list = [...otherChargesList]
    for (let i = 0; i < list.length; i++) {
      if (i == index) {
        list[i]['AccountTypeID'] = e.target.value
      }
      if (list[i]['AccountTypeID'] == 'Select') {
        list[i]['Amount'] = ''
      }
    }

    this.setState({
      otherChargesList: list
    })

  }

  handleCancel() {
    this.props.navigate('/accountReceiptsList')
  }

  maxLengthCheck = (object, maxLength) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  handleContinue() {
    const { totalAmount, performaInvoiceRecieptList } = this.state
    this.setState({ show: false })

    var list = [...performaInvoiceRecieptList];

    for (var i = 0; i < performaInvoiceRecieptList.length; i++) {
      if (performaInvoiceRecieptList[i].Is_Check == 1) {
        console.log("condition1",)
        if (list.length == 0) {
          list.push(performaInvoiceRecieptList[i])
        } else {
          var isAvailable = false;
          for (var j = 0; j < list.length; j++) {
            if (list[j].ProformaInvoiceID == performaInvoiceRecieptList[i].ProformaInvoiceID) {
              isAvailable = true;
            }
          }
          if (!isAvailable) {
            list.push(performaInvoiceRecieptList[i])
          }
        }
      } else {
        for (var k = 0; k < list.length; k++) {
          if (list[k].ProformaInvoiceID == performaInvoiceRecieptList[i].ProformaInvoiceID) {
            list.splice(k, 1)
          }
        }
      }
    }

    console.log("*****************", list)

    this.setState({ chekedPerformaList: list, paidAmount: list[0]['PaidAmount'] }, () => {
      // console.log("222=======@@@@@@", checkedInvList)
      this.autoFillReceivedAmount()
    })
    setTimeout(() => {
      this.calculateTotals()
    }, 300);

    setTimeout(() => {
      const { totalCurrPend } = this.calculateTotals()
      if (totalCurrPend != 0) {
        this.handleOnAccAmt()
      } else {
        this.setState({ onAccAmt: 0.00 })
      }
    }, 500);
  }

  preventNegative(e) {
    (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()

    if (e.code === 'Minus') {
      e.preventDefault();
    }
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      const currentVal = parseFloat(e.target.value);
      const increment = e.key === "ArrowUp" ? 1 : -1;
      const newVal = currentVal + increment;
      if (newVal < 0) {
        e.preventDefault()
      }
    }
  }

  handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData('text/plain');
    const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

    // Replace the input value with the sanitized value
    document.execCommand('insertText', false, sanitizedValue);

    event.preventDefault(); // Prevent the default paste behavior
  }

  receivedAmmountReceipt(e, index) {
    const { chekedPerformaList } = this.state
    const newList = [...chekedPerformaList]
    const event = e.target.value.replace(/\D/, '')
    this.setState({ totalAmountErr: '' })

    newList.forEach((data, i) => {
      if (i === index) {
        if (parseFloat(data.Pending + data.PaidAmount) >= parseFloat(event)) {
          data.ReceivedAmount = event
        } else {
          toast.error("Received amount must be less than or equal to pending amount + paid amount", {
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          data.ReceivedAmount = ''
        }
      }
    });
    console.log("_____", newList)



    this.setState({
      chekedPerformaList: newList,
    });
  }

  calculateTotals() {
    try {
      const { chekedPerformaList } = this.state

      let totalTaxableAmt = 0;
      let totalPayableAmt = 0;
      let totalIgst = 0;
      let totalCgst = 0;
      let totalSgst = 0;
      let totalCurrPend = 0;
      let totalReceivedAmt = 0;
      let totalSecurityDeposit = 0;

      chekedPerformaList.forEach((data) => {
        if (data.Is_Check == 1) {
          totalTaxableAmt += Number(data.TaxableAmount);
          totalPayableAmt += Number(data.Total_Payable);
          totalIgst += Number(data.IGST);
          totalCgst += Number(data.CGST);
          totalSgst += Number(data.SGST);
          totalCurrPend += Number(data.Pending) + Number(data.PaidAmount);
          totalReceivedAmt += Number(data.ReceivedAmount)
          totalSecurityDeposit += Number(data.SecurityDeposit != null && data.SecurityDeposit != '' ? data.SecurityDeposit : 0)
        }
      });
      return {
        totalTaxableAmt,
        totalPayableAmt,
        totalIgst,
        totalCgst,
        totalSgst,
        totalCurrPend,
        totalReceivedAmt,
        totalSecurityDeposit,
      };

    } catch (e) {
      console.log('exception : ', e);
    }

  }

  sumOfObject(list, param) {
    const sumOfList = list.reduce((accumulator, value) => {
      if (param == 'Debit') {
        return accumulator + value.Debit;
      } else {
        return accumulator + value.Credit;
      }
    }, 0);

    return sumOfList
  }

  generateVoucher() {
    const { clientNameId, bankAccountId, currency, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, performaInvoiceRecieptList, otherChargesList, subledgerList, ledgerList, voucherId, account, ammount, chekedPerformaList, ReceiptId, paidAmount } = this.state
    const { totalReceivedAmt } = this.calculateTotals()
    var receiveAccAmount = (onAccAmt != '' && onAccAmt != null ? parseFloat(onAccAmt) + parseFloat(totalReceivedAmt) : totalReceivedAmt != '' ? parseFloat(totalReceivedAmt) : 0)
    console.log("receiveAccAmount", receiveAccAmount)
    console.log("totalAmount 33333", totalAmount)
    const performaArray = [];
    chekedPerformaList.map((data, i) => {
      performaArray.push(
        {
          'ProformaID': data.ProformaInvoiceID,
          'ReceivedAmount': data.ReceivedAmount,
        }
      )
    })

    const otherChargesArray = []
    otherChargesList.map((data, i) => {
      if (data.AccountTypeID != '' && data.AccountTypeID != 'Select' && data.Amount != '') {
        otherChargesArray.push(
          {
            'AccountTypeID': data.AccountTypeID,
            'Amount': data.Amount
          }
        )
      }
    })

    // const performaInvoiceRecieptArray = []
    // performaInvoiceRecieptList.map((data) => {
    //   if (data.Is_Check == 1) {
    //     performaInvoiceRecieptArray.push(data)
    //   }
    // })
    console.log("chekedPerformaList---", chekedPerformaList)
    var ReceivedAmount = false
    const performatList = chekedPerformaList.every(item => item.ReceivedAmount != '' && item.ReceivedAmount != 0)
    if (performatList) {
      ReceivedAmount = true
    } else {
      ReceivedAmount = false
    }

    console.log("ReceivedAmount", ReceivedAmount)
    console.log("totalReceivedAmt", totalReceivedAmt)

    // this.setState({ isLoading: true });
    this.inputValidate()
    if (voucherId != '' && voucherId != 'Select' && tdsAmount != '' && clientNameId != '' && bankAccountId != '' && bankAccountId != 'Select' && bankAmount != '') {
      if (performaArray != '') {
        if (totalReceivedAmt != '') {
          if (ReceivedAmount) {
            if (parseInt(receiveAccAmount) == parseInt(totalAmount)) {
              this.props
                .generate_invoice_action(clientNameId, parseInt(bankAccountId), currency != '' ? 1 : null, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt != '' ? onAccAmt : 0, crAmount != '' ? crAmount : 0, totalAmount, performaArray, otherChargesArray, ReceiptId)
                .then((data) => {
                  if (data.error != 1) {
                    this.setState({ isLoading: false, isGenVoucherDisabled: true, isEditGenerateVoucher: false });
                    // if (this.props.location.state.Is_update) {
                    //   this.setState({ isEditGenerateVoucher: true });
                    // } else {
                    //   this.setState({ isEditGenerateVoucher: false });
                    // }
                    var ledgerList = data.data.ledger
                    var ledgerDebitSum = 0
                    var ledgerCreditSum = 0
                    var mapLedger;
                    for (var i = 0; i < ledgerList.length; i++) {
                      ledgerDebitSum = ledgerDebitSum + ledgerList[i].Debit
                      ledgerCreditSum = ledgerCreditSum + ledgerList[i].Credit
                      // if (i == (ledgerList.length - 1)) {
                      //   mapLedger = {
                      //     Account: "Total",
                      //     Credit: ledgerCreditSum,
                      //     Debit: ledgerDebitSum
                      //   }
                      // }
                    }
                    if (mapLedger != null) {
                      ledgerList.push(mapLedger)
                    }
                    //adding some of sub-ledger........................
                    var subledgerList = data.data.subledger
                    var subledgerDebitSum = 0
                    var subledgerCreditSum = 0
                    var mapSubLedger;
                    for (var i = 0; i < subledgerList.length; i++) {
                      subledgerDebitSum = subledgerDebitSum + subledgerList[i].Debit
                      subledgerCreditSum = subledgerCreditSum + subledgerList[i].Credit
                      if (i == (subledgerList.length - 1)) {
                        mapSubLedger = {
                          Account: "Total",
                          Credit: subledgerCreditSum,
                          Debit: subledgerDebitSum
                        }
                      }
                    }
                    if (mapSubLedger != null) {
                      subledgerList.push(mapSubLedger)
                    }

                    this.setState({
                      isLoading: false,
                      ledgerList: ledgerList,
                      subLedgerList: subledgerList
                    })

                  } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                      //after session expire.....................
                      sessionStorage.clear()
                      this.props.navigate('/normalView')
                      setTimeout(() => {
                        toast.error(data.msg, {
                          position: "top-center",
                          theme: "colored",
                          autoClose: 3000,
                          hideProgressBar: true,
                        });
                      }, 500);
                    } else {
                      this.setState({ isLoading: false });
                      toast.error(data.data, {
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }
                  }
                })
                .catch((e) => {
                  console.log(e);
                });

            } else {
              toastError("Total amounts are not matched")
              this.setState({ totalAmountErr: 'Total amounts are not matched' })
            }
          } else {
            toastError("please enter received amount")
          }
        } else {
          toastError("please enter received amount")
        }
      } else {
        toastError("please select proforma list")
      }
    } else {
      toastError("Please enter mandatory fields!")
    }
  }

  clearVoucher() {

    if (this.props.location.state.Is_update) {
      this.setState({ isEditGenerateVoucher: true, isDisplayClientList: false })
    } else {
      this.setState({
        isDisplayClientList: false,
      })
    }
    this.setState({
      isGenVoucherDisabled: false
    })
    // window.location.reload()

  }

  onLedgerDebit(e, i) {
    const { ledgerList } = this.state
    const event = e.target.value
    ledgerList.map((item, index) => {
      if (i === index) {
        if (event != '') {
          item.Debit = parseFloat(event)
        } else {
          item.Debit = ''
        }
      }
    })
    this.setState({ ledgerList: ledgerList })
  }
  onLedgerCredit(e, i) {
    const { ledgerList } = this.state
    const event = e.target.value
    ledgerList.map((item, index) => {
      if (i === index) {
        if (event != '') {
          item.Credit = parseFloat(event)
        } else {
          item.Credit = 0
        }
      }
    })
    console.log('ledgerList----', ledgerList)
    const value = this.sumObjectValues(ledgerList)
    console.log('value----', value)
    if (ledgerList[7]['Debit'] != value) {
      this.setState({ LedgerCreditAmountErr: 'Total Credit amount must match the total Receipt amount' })
    } else {
      this.setState({ LedgerCreditAmountErr: '' })
    }
    this.setState({ ledgerList: ledgerList })
  }

  sumObjectValues(arr) {
    let sum = 0;
    arr.forEach(item => {
      for (const key in item) {
        if (key === 'Credit') {
          sum += item.Credit;
        }
      }
    });
    sum = Math.round(sum * 100) / 100;

    // Format with commas and two decimal places
    // return sum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    return sum
  }

  //For Ledger Table Create 
  createLedgerTable() {
    const { ledgerList, LedgerCreditAmountErr, onPreview } = this.state
    var list = [...ledgerList]
    var ledgerColumnArray = []
    var ledgerRowData = []
    // saving all keys of ledger data
    list.map((data, index) => {
      if (index == 0) {
        Object.keys(data).map((key, i) => {
          ledgerColumnArray.push(key)
        })
      }
    })
    // saving all row data 
    list.map((data) => {
      ledgerRowData.push(data)
    })

    return (
      <div class="col-md-6">
        <div>
          <div class="">
            <div class="row mr_0">
              <div class="col-md-12 padding_0">
                <h6 class="mb_0">Ledger</h6>
              </div>
            </div>
          </div>
          <div class="custom_table">
            <div class="hack1">
              <div class="hack2">
                <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                  <thead>
                    <tr key={Math.random()} >
                      {
                        ledgerColumnArray.length > 0 && ledgerColumnArray.map((data, index) => (
                          <th>{data}</th>
                        ))
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      ledgerRowData.length > 0 && ledgerRowData.map((data, i) => (
                        <tr key={i}>
                          <td>{data.Account}</td>
                          <td>
                            <input
                              type="number"
                              className="form-control hideIncDec"
                              placeholder={0}
                              value={data.Debit}
                              onChange={(e) => this.onLedgerDebit(e, i)}
                              maxLength={10}
                              disabled={true}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control hideIncDec"
                              placeholder={0}
                              maxLength={10}
                              value={data.Credit}
                              onChange={(e) => this.onLedgerCredit(e, i)}
                              onPaste={(e) => this.handlePaste(e)}
                              onInput={(e) => this.maxLengthCheck(e, 16)}
                              onKeyDown={(e) => this.preventNegative(e)}
                              disabled={onPreview}
                            />
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
                <span className='text-danger text-start text-left d-block mt-1'>{LedgerCreditAmountErr}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  //create sub Ledger Table
  createSubLedgerTable() {
    const { subLedgerList } = this.state
    var list = [...subLedgerList]
    var subLedgerColumnArray = []
    var subLedgerRowData = []
    // saving all keys of ledger data
    list.map((data, index) => {
      if (index == 0) {
        Object.keys(data).map((key, i) => {
          subLedgerColumnArray.push(key)
        })
      }
    })
    // saving All row data
    list.map((data) => {
      subLedgerRowData.push(data)
    })
    return (
      <div class="col-md-6">
        <div>
          <div class="">
            <div class="row mr_0">
              <div class="col-md-12 padding_0">
                <h6 class="mb_0">Sub Ledger</h6>
              </div>
            </div>
          </div>
          <div class="custom_table">
            <div class="hack1">
              <div class="hack2">
                <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                  <thead>
                    <tr key={Math.random()}>
                      {
                        subLedgerColumnArray.length > 0 && subLedgerColumnArray.map((data) => (
                          <th>{data}</th>
                        ))
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      subLedgerRowData.length > 0 && subLedgerRowData.map((data, index) => (
                        <tr>
                          <td>{data.Account}</td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={0.0}
                              value={data.Debit}
                              disabled={true}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={330.0}
                              value={data.Credit}
                              disabled={true}
                            />
                          </td>
                        </tr>
                      ))
                    }

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }

  onBankAmount(e) {
    const event = e.target.value
    this.setState({ bankAmount: event, bankAmountErr: '' })
    if (event != '') {
      this.setState({ isDisableProformaInvoice: false })
    } else {
      this.setState({ isDisableProformaInvoice: true })
    }

  }

  render() {
    const {
      isLoading, receiptPreviewModal, receiptFilePath,
      voucherId,
      voucherList,
      bankAccountId,
      bankAccountList,
      paymentModeId,
      paymentModeList,
      receiptAccountTypeId,
      receiptAccountTypeList,
      clientNameId,
      clientNameList,
      show,
      performaInvoiceRecieptList,
      otherChargesList,
      currency,
      conversionRate,
      bankAmount,
      tdsAmount,
      exchdiif,
      crAmount,
      totalAmount,
      receiptNo,
      receiptDate,
      paymentReceivedDate,
      instrumentNo,
      instrumentDate,
      bankName,
      branchName,
      narration,
      Is_update,
      voucherTypeErr,
      clientErr,
      bankAccountErr,
      bankAmountErr,
      tdsAmountErr,
      pymtModeErr,
      otherChargesListErr,
      totalsErr,
      onAccAmt,
      isGenVoucherDisabled,
      checkAll,
      isDisplayClientList,
      ReceivedAmount,
      isEditGenerateVoucher,
      onPreview,
      chekedPerformaList,
      isDisableProformaInvoice,
      totalAmountErr,
      buttomButtonList,
      rptDetailsObj,
      adminReceipt,
      paidAmount,
      piSendShow,
      OrderNo,
      taxInvoiceFilePath,
      isTaxInvoiceFlag
    } = this.state;



    const { totalTaxableAmt, totalPayableAmt, totalIgst, totalCgst, totalSgst, totalCurrPend, totalReceivedAmt, totalSecurityDeposit } = this.calculateTotals()

    console.log(totalTaxableAmt, totalPayableAmt, totalIgst, totalCgst, totalSgst, totalCurrPend, totalReceivedAmt, totalSecurityDeposit)
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[22]} />

            <section style={{ marginTop: "115px" }}>
              <div class="container-fluid">
                <div class="page-header">
                  <h4 class="page-title">Receipts</h4>
                </div>

                <div class="search_accordion search_card">
                  <div class="panel-group" id="accordion">
                    <div class="panel panel-default">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>Voucher<span style={{ color: 'red' }}>*</span></label>
                              <select
                                id="state"
                                name="Entry Type"
                                class="form-control floating-control"
                                value={voucherId}
                                disabled={isGenVoucherDisabled || onPreview}
                                onChange={(e) =>
                                  this.setState({ voucherId: e.target.value, voucherTypeErr: "" })
                                }
                              >
                                <option>Select</option>
                                {voucherList.length > 0 &&
                                  voucherList.map((item) => (
                                    <option

                                      key={item.VoucherTypeID}
                                      value={item.VoucherTypeID}
                                    >
                                      {item.VoucherTypeName}
                                    </option>
                                  ))}
                              </select>{<span className='text-danger text-start text-left d-block mt-1'>{voucherTypeErr}</span>}
                            </div>
                          </div>
                          {/* <div class="col-md-4">
                              <div class="form-group mb-3">
                                <label>Organizer Name<span style={{ color: 'red' }}>*</span></label>
                                <input
                                  disabled={isGenVoucherDisabled || onPreview}
                                  type="text"
                                  className="form-control"
                                  id="validationCustom03"
                                  value={clientNameId}
                                  onChange={(e) => this.onClientSearch(e)}
                                  autocomplete="off"
                                />
                                {isDisplayClientList && this.renderClientList()}
                                {<span className='text-danger text-start text-left d-block mt-1'>{clientErr}</span>}
                              </div>
                            </div> */}
                          <div class="col-md-4">
                            <label>Organizer Name<span style={{ color: 'red' }}>*</span></label>
                            <select
                              id="state"
                              name="Entry Type"
                              class="form-control floating-control"
                              value={clientNameId}
                              disabled={Is_update || isGenVoucherDisabled || onPreview || this.props.location.state.adminReceipt}
                              onChange={(e) =>
                                this.onClientSelect(e)
                              }
                            >
                              <option>Select</option>
                              {clientNameList.length > 0 &&
                                clientNameList.map((item) => (
                                  <option
                                    key={item.ClientID}
                                    value={item.ClientID}
                                  >
                                    {item.Client}
                                  </option>
                                ))}
                            </select>{<span className='text-danger text-start text-left d-block mt-1'>{clientErr}</span>}
                          </div>
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>Bank Account <span style={{ color: 'red' }}>*</span></label>
                              <select
                                disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                id="state"
                                name="Entry Type"
                                class="form-control floating-control"
                                value={bankAccountId}
                                onChange={(e) =>
                                  this.setState({
                                    bankAccountId: e.target.value,
                                    bankAccountErr: ""
                                  })
                                }
                              >
                                <option>Select</option>
                                {bankAccountList.length > 0 &&
                                  bankAccountList.map((item) => (
                                    <option
                                      key={item.BankID}
                                      value={item.BankID}
                                    >
                                      {item.Name}
                                    </option>
                                  ))}
                              </select>{<span className='text-danger text-start text-left d-block mt-1'>{bankAccountErr}</span>}
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>Currency</label>
                              <input
                                value={currency}
                                type="text"
                                class="form-control"

                                disabled={true}
                              />
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>Conversion Rate</label>
                              <input
                                value={conversionRate}
                                type="text"
                                class="form-control"

                                disabled={true}
                              />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>Bank Amount <span style={{ color: 'red' }}>*</span></label>
                              <input
                                disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                value={bankAmount}
                                type="number"
                                class="form-control hideIncDec"
                                maxLength={'16'}
                                onChange={(e) => this.onBankAmount(e)}
                                onPaste={(e) => this.handlePaste(e)}
                                onInput={(e) => this.maxLengthCheck(e, 16)}
                                onKeyDown={(e) => this.preventNegative(e)}
                                onBlur={(e) => this.handleBankAmount(e)}
                              />{<span className='text-danger text-start text-left d-block mt-1'>{bankAmountErr}</span>}
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>TDS Amount
                                <span style={{ color: 'red' }}>*</span>
                              </label>
                              <input
                                disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                value={tdsAmount}
                                maxLength={'16'}
                                type="number"
                                class="form-control hideIncDec"
                                onChange={(e) => this.setState({ tdsAmount: e.target.value, tdsAmountErr: "" })}
                                onKeyDown={(e) => this.preventNegative(e)}
                                onInput={(e) => this.maxLengthCheck(e, 16)}
                                onPaste={(e) => this.handlePaste(e)}
                                onBlur={(e) => this.handletdsAmount(e)}
                              />{<span className='text-danger text-start text-left d-block mt-1'>{tdsAmountErr}</span>}
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>Exch Diff</label>
                              <input
                                disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                value={exchdiif}
                                type="number"
                                class="form-control hideIncDec"
                                maxLength={'16'}
                                onChange={(e) => e.target.value >= 0 && this.setState({ exchdiif: e.target.value.replace(/\D/, '') })}
                                onKeyDown={(e) => this.preventNegative(e)}
                                onInput={(e) => this.maxLengthCheck(e, 16)}
                                onPaste={(e) => this.handlePaste(e)}
                                onBlur={(e) => this.setState({ exchdiif: e.target.value != '' ? parseFloat(e.target.value).toFixed(2) : '' })}
                              />
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>On Acc Amt</label>
                              <input
                                type="number"
                                class="form-control hideIncDec"
                                value={onAccAmt}
                                maxLength={'16'}
                                disabled={true}
                                onInput={(e) => this.maxLengthCheck(e, 16)}
                                onKeyDown={(e) => this.preventNegative(e)}
                                onPaste={(e) => this.handlePaste(e)}
                              />
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>Cr Amount</label>
                              <input
                                type="number"
                                class="form-control hideIncDec"
                                value={crAmount}
                                maxLength={'16'}
                                disabled={true}
                                onInput={(e) => this.maxLengthCheck(e, 16)}
                                onKeyDown={(e) => this.preventNegative(e)}
                                onPaste={(e) => this.handlePaste(e)}
                                onBlur={(e) => this.setState({ crAmount: parseFloat(e.target.value).toFixed(2) })}
                              />
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group mb-3">
                              <label>Total Amount</label>
                              <input
                                type="text"
                                class="form-control"
                                value={totalAmount}
                                maxLength={'16'}
                                disabled={true}
                                onInput={(e) => this.maxLengthCheck(e, 16)}
                                onKeyDown={(e) => this.preventNegative(e)}
                                onPaste={(e) => this.handlePaste(e)}
                              />
                              {<span className='text-danger text-start text-left d-block mt-1'>{totalAmountErr}</span>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card Service_fields" style={{ marginBottom: "2rem" }}>

                  <div className="card-body">
                    <div className="company_info">
                      <div class="receipt_report ">
                        <div class="row mr-0">
                          <div class="col-md-6 padding_0">
                            <h6>&nbsp;</h6>
                          </div>
                          <div class="col-md-6 padding_0">
                            <div class="text-right">
                              <button
                                onClick={() => this.modalShow()}
                                class="btn btn-primary btn-sm"
                                disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview || isDisableProformaInvoice || Is_update || adminReceipt}
                              >
                                <i class="fa fa-plus" /> Select Proforma
                                Invoice(s)
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="custom_table">
                        <div class="hack1">
                          <div class="hack2">
                            <table
                              class="table table-bordered table-striped"
                              id="dashboard-table"
                            >
                              <thead>
                                <tr>
                                  <th>Proforma Invoice No</th>
                                  <th>Application No</th>
                                  <th>Proforma Date</th>
                                  {/* <th>Details</th> */}
                                  <th>Proforma Type</th>
                                  <th>Taxable Amount</th>
                                  {/* <th>Tax Type</th> */}
                                  <th>CGST</th>
                                  <th>SGST</th>
                                  <th>IGST</th>
                                  <th>Security Deposit</th>
                                  <th>Total Payable</th>
                                  <th>Paid Amount</th>
                                  <th>Pending</th>
                                  <th style={{ width: '10%' }}>Received Amount</th>
                                </tr>
                              </thead>
                              <tbody id="myTable">
                                {chekedPerformaList != "" &&
                                  chekedPerformaList != null ? (
                                  chekedPerformaList.map((data, i) => (
                                    <>
                                      <tr>
                                        <td>{data.ProformaInvoice_No}</td>
                                        <td>{data.OrderID}</td>
                                        <td>{data.ProformaInvoice_Date != null ? moment(data.ProformaInvoice_Date).format('DD-MM-YYYY') : <></>}</td>
                                        {/* <td>{data.Details}</td> */}
                                        <td>{data.ProformaType}</td>
                                        <td style={{ textAlign: 'right' }}>{data.TaxableAmount != null ? data.TaxableAmount.toLocaleString("en-IN") : '-'}</td>
                                        {/* <td style={{ textAlign: 'right' }}>{data.Tax_Type}</td> */}
                                        <td style={{ textAlign: 'right' }}>{data.CGST != 0 && data.CGST != '' ? data.CGST.toLocaleString("en-IN") : '-'}</td>
                                        <td style={{ textAlign: 'right' }}>{data.SGST != 0 && data.SGST != '' ? data.SGST.toLocaleString("en-IN") : '-'}</td>
                                        <td style={{ textAlign: 'right' }}>{data.IGST != 0 && data.IGST != '' ? data.IGST.toLocaleString("en-IN") : '-'}</td>
                                        <td style={{ textAlign: 'right' }}>
                                          {data.SecurityDeposit != null && data.SecurityDeposit != '' ? data.SecurityDeposit.toLocaleString("en-IN") : '-'}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>{data.Total_Payable != '' && data.Total_Payable != null ? data.Total_Payable.toLocaleString("en-IN") : 0}</td>
                                        <td style={{ textAlign: 'right' }}>{paidAmount != '' && paidAmount != null ? paidAmount.toLocaleString("en-IN") : 0}</td>
                                        <td style={{ textAlign: 'right' }}>{data.Pending != '' && data.Pending != null ? data.Pending.toLocaleString("en-IN") : 0}</td>
                                        <td>
                                          <input
                                            style={{ textAlign: 'right' }}
                                            type="text"
                                            class="form-control"
                                            disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                            value={data.ReceivedAmount}
                                            onChange={(e) => this.receivedAmmountReceipt(e, i)}
                                          />
                                        </td>
                                      </tr>
                                      {/* {data.ProformaType != 'Additionalservices' ?
                                          <tr>
                                            <td>{data.ProformaInvoice_No}</td>
                                            <td>{data.ProformaInvoice_Date != null ? moment(data.ProformaInvoice_Date).format('DD-MM-YYYY') : <></>}</td>
                                            <td>{data.Details}</td>
                                            <td>{data.ProformaType}</td>
                                            <td style={{ textAlign: 'right' }}>-</td>
                                            <td style={{ textAlign: 'right' }}>50,000</td>
                                            <td style={{ textAlign: 'right' }}>-</td>
                                            <td style={{ textAlign: 'right' }}>-</td>
                                            <td style={{ textAlign: 'right' }}>-</td>
                                            <td style={{ textAlign: 'right' }}>-</td>
                                            <td style={{ textAlign: 'right' }}>50,000</td>
                                            <td style={{ textAlign: 'right' }}>-</td>
                                            <td>
                                              <input
                                                style={{ textAlign: 'right' }}
                                                type="text"
                                                class="form-control"
                                                disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                                value={data.ReceivedAmount}
                                                onChange={(e) => this.receivedAmmountReceipt(e, i)}
                                              />
                                            </td>
                                          </tr>
                                          : <></>} */}
                                    </>
                                  )
                                  )
                                ) : (
                                  <></>
                                )}
                                {
                                  <tr>
                                    <td>Total</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td style={{ textAlign: 'right' }}>{totalTaxableAmt != '' ? totalTaxableAmt.toLocaleString("en-IN") : ''}</td>
                                    {/* <td style={{ textAlign: 'right' }}>-</td> */}
                                    {/* <td style={{ textAlign: 'right' }}>-</td> */}
                                    <td style={{ textAlign: 'right' }}>{totalCgst != 0 && totalCgst != '' ? totalCgst.toLocaleString("en-IN") : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{totalSgst != 0 && totalSgst != '' ? totalSgst.toLocaleString("en-IN") : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{totalIgst != 0 && totalIgst != '' ? totalIgst.toLocaleString("en-IN") : '-'}</td>
                                    <td style={{ textAlign: 'right' }}>{totalSecurityDeposit != '' ? totalSecurityDeposit.toLocaleString("en-IN") : ''}</td>
                                    <td style={{ textAlign: 'right' }}>{totalPayableAmt != '' ? totalPayableAmt.toLocaleString("en-IN") : ''}</td>
                                    <td style={{ textAlign: 'right' }}>{paidAmount != '' && paidAmount != null ? paidAmount.toLocaleString("en-IN") : 0}</td>
                                    <td style={{ textAlign: 'right' }}>{totalCurrPend != '' ? totalCurrPend.toLocaleString("en-IN") : ''}</td>
                                    <td style={{ textAlign: 'right' }}>{totalReceivedAmt != '' ? totalReceivedAmt.toLocaleString("en-IN") : ''}</td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div>
                          <div class="">
                            <div class="row mr_0">
                              <div class="col-md-12 padding_0">
                                <h6 class="mb_0">Other Charges</h6>
                              </div>
                            </div>
                          </div>
                          <div class="custom_table">
                            <div class="hack1">
                              <div class="hack2">
                                <table
                                  class="table table-bordered table-striped"
                                  id="dashboard-table"
                                >
                                  <thead>
                                    <tr>
                                      <th>Account</th>
                                      <th>Amount</th>
                                      <th class="text-right">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody id="myTable">
                                    {
                                      otherChargesList.map((data, i) => (
                                        <tr>
                                          <td>
                                            <select
                                              id="state"
                                              name="Entry Type"
                                              class="form-control floating-control"
                                              value={data.AccountTypeID}
                                              onChange={(e) => this.otherChargesReceiptAccountTypeId(e, i)
                                              }
                                              disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                            >
                                              <option>Select</option>
                                              {receiptAccountTypeList.length > 0 &&
                                                receiptAccountTypeList.map(
                                                  (item) => (
                                                    <option
                                                      key={
                                                        item.ReceiptAccountTypeID
                                                      }
                                                      value={
                                                        item.ReceiptAccountTypeID
                                                      }
                                                    >
                                                      {item.AccountType}
                                                    </option>
                                                  )
                                                )}
                                            </select>
                                          </td>
                                          <td>
                                            <input
                                              type="number"
                                              class="form-control hideIncDec"
                                              disabled={data.AccountTypeID == '' || data.AccountTypeID == 'Select' || isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                              value={data.Amount}
                                              onChange={(e) => this.otherChargesReceiptAmount(e, i)}
                                            />
                                          </td>
                                          <td class="text-right">
                                            {otherChargesList.length == i + 1 ? (
                                              <>
                                                {
                                                  onPreview ? isEditGenerateVoucher : !isGenVoucherDisabled ?
                                                    <a
                                                      title="Edit"
                                                      class="btn btn-sm"
                                                      onClick={() =>
                                                        this.addOtherCharges(
                                                          data.deleteRowId + 1
                                                        )
                                                      }
                                                    >
                                                      <i class="fa fa-plus action_btn_table"></i>
                                                    </a>
                                                    : <a
                                                      title="Edit"
                                                      class="btn btn-sm"
                                                    >
                                                      <i class="fa fa-plus action_btn_table"></i>
                                                    </a>
                                                }
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                            {otherChargesList.length != 1 ? (
                                              <>
                                                {
                                                  onPreview ? isEditGenerateVoucher : !isGenVoucherDisabled ?
                                                    <a
                                                      title="Delete"
                                                      class="btn btn-sm delete_record"
                                                      onClick={() =>
                                                        this.deleteOtherCharges(
                                                          data.deleteRowId
                                                        )
                                                      }
                                                    >
                                                      <i class="fa fa-trash action_btn_table"></i>
                                                    </a>
                                                    : <a
                                                      title="Delete"
                                                      class="btn btn-sm delete_record"
                                                    >
                                                      <i class="fa fa-trash action_btn_table"></i>
                                                    </a>
                                                }
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        </tr>
                                      ))
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 text-right">
                        {
                          isGenVoucherDisabled && !isEditGenerateVoucher ?
                            <button class="btn btn-primary btn-sm"
                              onClick={() => this.clearVoucher()}
                            >Clear Voucher</button>
                            :
                            <button class="btn btn-primary btn-sm"
                              onClick={() => this.generateVoucher()}
                            >Generate Voucher</button>
                        }
                      </div>
                    </div>

                    <div class="row">
                      {
                        isGenVoucherDisabled && !isEditGenerateVoucher && this.createLedgerTable()
                      }
                      {
                        isGenVoucherDisabled && !isEditGenerateVoucher && this.createSubLedgerTable()
                      }
                    </div>

                    <div>
                      <div class="row mt-2">
                        <div class="col-md-12 mb-3">
                          <label>Narration</label>
                          <textarea
                            value={narration}
                            onChange={(e) => this.setState({ narration: e.target.value })}
                            class="form-control"
                            rows="3"
                            placeholder="type here"
                            disabled={onPreview}
                          ></textarea>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2 mb-3">
                          <label>Receipt no</label>
                          <input type="text"
                            value={receiptNo}
                            class="form-control" disabled />
                        </div>
                        <div class="col-md-2 mb-3">
                          <label>Receipt Date</label>
                          <input type="text"
                            value={receiptDate != '' ? moment(receiptDate).format('DD-MM-YYYY') : ''}
                            onChange={(e) => this.setState({ receiptDate: e.target.value })}
                            class="form-control" disabled />
                        </div>
                        <div class="col-md-2 mb-3">
                          <label>Payment Received Date</label>
                          <div style={{ zIndex: '99' }} className="form-group d-flex" >
                            <DatePicker className="form-control"
                              dateFormat="dd-MM-yyyy"
                              maxDate={new Date}
                              selected={paymentReceivedDate}
                              onChange={(date) => {
                                this.setState({ paymentReceivedDate: date })
                              }}
                              disabled={onPreview}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                            />
                            {/* {console.log("instrumentDate DatePicker", instrumentDate)} */}
                          </div>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label>Payment Mode<span style={{ color: 'red' }}>*</span></label>
                          <select
                            id="state"
                            name="Entry Type"
                            class="form-control floating-control"
                            value={paymentModeId}
                            disabled={onPreview}
                            onChange={(e) =>
                              this.setState({ paymentModeId: e.target.value, pymtModeErr: '' })
                            }
                          >
                            <option>Select</option>
                            {paymentModeList.length > 0 &&
                              paymentModeList.map((item) => (
                                <option
                                  key={item.PaymentModeID}
                                  value={item.PaymentModeID}
                                >
                                  {item.Name}
                                </option>
                              ))}
                          </select>{<span className='text-danger text-start text-left d-block mt-1'>{pymtModeErr}</span>}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2 mb-3">
                          <label>Instrument no</label>
                          <input type="text"
                            value={instrumentNo}
                            disabled={onPreview}
                            onChange={(e) => this.setState({ instrumentNo: e.target.value })}
                            class="form-control" />
                        </div>
                        <div class="col-md-2 mb-3">
                          <label>Instrument Date</label>
                          <div style={{ zIndex: '99' }} className="form-group d-flex" >
                            <DatePicker className="form-control"
                              dateFormat="dd-MM-yyyy"
                              selected={instrumentDate}
                              onChange={(date) => {
                                this.setState({ instrumentDate: date })
                              }}
                              disabled={onPreview}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                            />
                            {/* {console.log("instrumentDate DatePicker", instrumentDate)} */}
                          </div>
                        </div>
                        <div class="col-md-2 mb-3">
                          <label>Bank Name</label>
                          <input type="text"
                            onChange={(e) => this.setState({ bankName: e.target.value })}
                            value={bankName}
                            disabled={onPreview}
                            class="form-control" />
                        </div>
                        <div class="col-md-2 mb-3">
                          <label>Branch Name</label>
                          <input type="text"
                            onChange={(e) => this.setState({ branchName: e.target.value })}
                            value={branchName}
                            disabled={onPreview}
                            class="form-control" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12 text-right">

                        {
                          Is_update == true || onPreview ?
                            <>
                              {buttomButtonList['isOutstandingZero'] ?
                                <>
                                  {buttomButtonList['isOutstandingZero'] && buttomButtonList['isNoDue'] ?
                                    <a
                                      href="javascript:void(0);"
                                      className="make_paymentLink m-2"
                                      onClick={() =>
                                        this.downloadNoDue(
                                        )
                                      }
                                    >
                                      <i className="fa fa-download" /> No Due Certificate
                                    </a>
                                    :
                                    <a
                                      href="javascript:void(0);"
                                      className="btn btn-outline-primary btn-sm m-2 make_paymentBtn"
                                      onClick={() =>
                                        this.generateNoDue(
                                          this.props.location.state.OrderID,
                                          this.props.location.state.OrderNo,
                                        )
                                      }
                                    >
                                      Generate and Send No Due Certificate
                                    </a>
                                  }

                                  {buttomButtonList['FinalExitSubmit'] ?
                                    <>
                                      {buttomButtonList['FinalExitSubmit'] && buttomButtonList['IsTaxInvoiceGenerated'] || isTaxInvoiceFlag ?
                                        <a
                                          href="javascript:void(0);"
                                          className="make_paymentLink m-2"
                                          onClick={() =>
                                            this.generateTaxInvoice()
                                          }
                                        >
                                          <i className="fa fa-download" /> Download and Send Tax Invoice
                                        </a> : <a
                                          href="javascript:void(0);"
                                          className="btn btn-outline-primary btn-sm m-2 make_paymentBtn"
                                          onClick={() =>
                                            this.generateTaxInvoice()
                                          }
                                        >
                                          Generate and Send Tax Invoice
                                        </a>
                                      }
                                    </>
                                    : <></>}
                                  {buttomButtonList['FinalExitSubmit'] ?
                                    <>
                                      {buttomButtonList['isExitPass'] && buttomButtonList['FinalExitSubmit'] ?
                                        <a
                                          href="javascript:void(0);"
                                          className="make_paymentLink m-2"
                                          onClick={() =>
                                            this.downloadExitPass()
                                          }
                                        >
                                          <i className="fa fa-download" />  Exit Pass
                                        </a>
                                        :
                                        <a
                                          href="javascript:void(0);"
                                          className="btn btn-outline-primary btn-sm m-2 make_paymentBtn"
                                          onClick={() =>
                                            this.updateExitPass()
                                          }
                                        >
                                          Generate and Send Exit Pass
                                        </a>
                                      }
                                    </>
                                    : <></>}
                                </>
                                : <></>}

                              <a
                                onClick={() => this.previewReceipt()}
                                class="report_btns m-1"
                                style={{ cursor: 'pointer' }}
                              >
                                Send Receipt
                              </a>
                              <a
                                onClick={() => this.updateAccountReceiptList()}
                                class="report_btns m-1"
                                style={{ cursor: 'pointer' }}
                              >
                                Update
                              </a>
                            </>
                            :
                            <a
                              onClick={() => this.addAccountReceiptList()}
                              class="report_btns m-1"
                              style={{ cursor: 'pointer' }}
                            >
                              Add
                            </a>
                        }

                        <a onClick={() => this.handleCancel()} class="report_btns m-2" style={{ cursor: 'pointer' }}>
                          Cancel
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main >
        </>
        <ToastContainer />

        <Modal show={show} size="xl">
          <Modal.Header>
            <Modal.Title>Select Proforma Invoice</Modal.Title>
            <span
              onClick={this.modalClose}
              style={{ cursor: "pointer", fontWeight: "800" }}
            >
              X
            </span>
          </Modal.Header>

          <Modal.Body>
            <table
              class="table table-bordered table-striped"
              id="dashboard-table"
            >
              <thead>
                <tr>
                  <th style={{ width: '5%' }}>
                    {/* <div class="bg">
                      <div class="chiller_cb" style={{ margin: "auto" }}>
                        <input
                          id="ServiceCheck1"
                          type="checkbox"
                          checked={checkAll}
                          onClick={(e) => this.tableHeadCheckbox(e)}
                        />
                        <label for="ServiceCheck1" style={{ color: "black" }}>
                          &nbsp;
                        </label>
                        <span></span>
                      </div>
                    </div> */}
                  </th>
                  <th style={{ width: '10%' }}>Proforma No</th>
                  <th style={{ width: '10%' }}>Application No</th>
                  <th style={{ width: '10%' }}>Proforma Date</th>
                  <th style={{ width: '10%' }}>Details</th>
                  {/* <th style={{ width: '10%' }}>Proforma Type</th> */}
                  <th style={{ width: '10%', textAlign: 'right' }}>Total Payable</th>
                  <th style={{ width: '10%', textAlign: 'right' }}>Pending Amount</th>
                </tr>
              </thead>
              <tbody id="myTable">
                {performaInvoiceRecieptList != "" &&
                  performaInvoiceRecieptList != null ? (
                  performaInvoiceRecieptList.map((data, i) => (
                    <tr>
                      <td>
                        <div class="bg">
                          <div class="chiller_cb" style={{ margin: "auto" }}>
                            <input
                              type="checkbox"
                              id={`checkbox${i}`}
                              checked={data.Is_Check}
                              onClick={(e) =>
                                this.tableBodyCheckbox(i, data.OrderID, e)
                              }
                            />
                            <label
                              for={`checkbox${i}`}
                              style={{ color: "#979797" }}
                            >
                              &nbsp;
                            </label>
                            <span></span>
                          </div>
                        </div>
                      </td>
                      <td >{data.ProformaInvoice_No}</td>
                      <td >{data.OrderID}</td>
                      <td style={{ textAlign: 'center' }}>{data.ProformaInvoice_Date != null ? moment(data.ProformaInvoice_Date).format('DD-MM-YYYY') : <></>}</td>
                      <td>{data.Details}</td>
                      <td style={{ textAlign: 'right' }}>{data.Total_Payable != '' && data.Total_Payable != null ? data.Total_Payable.toLocaleString("en-IN") : 0}</td>
                      <td style={{ textAlign: 'right' }}>{data.Pending != '' && data.Pending != null ? data.Pending.toLocaleString("en-IN") : 0}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      Record not found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <button
              type="submit"
              onClick={this.handleContinue}
              class="btn save_btn mr-2"
            >
              Continue
            </button>
          </Modal.Body>
        </Modal>

        <Modal
          show={piSendShow}
          // onHide={this.piModalClose}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>
              Tax Invoice for Order: {OrderNo}
            </Modal.Title>

          </Modal.Header>

          <Modal.Body>
            <div class="form-group">
              {taxInvoiceFilePath && (
                <iframe
                  title="Proforma Invoice Report"
                  src={taxInvoiceFilePath}
                  style={{
                    width: "100%",
                    height: "600px",
                    border: "none",
                  }}
                />
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ piSendShow: false })}
            >
              close
            </Button>
            <Button
              variant="success"
              onClick={() => this.downloadTaxInvoice()}
            >
              <i className="fa fa-download" /> Download Tax Invoice
            </Button>
            <Button
              variant="success"
              onClick={() => this.sendTaxInvoice()}
            >
              Send Tax Invoice
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={receiptPreviewModal}
          // onHide={this.piModalClose}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>
              Receipt for Order: {OrderNo}
            </Modal.Title>

          </Modal.Header>

          <Modal.Body>
            <div class="form-group">
              {receiptFilePath && (
                <iframe
                  title="Receipt"
                  src={receiptFilePath}
                  style={{
                    width: "100%",
                    height: "600px",
                    border: "none",
                  }}
                />
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ receiptPreviewModal: false })}
            >
              close
            </Button>
            <Button
              variant="success"
              onClick={() => this.onSendMailReceipt()}
            >
              <i className="fa fa-download" /> Send Receipt
            </Button>

          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    getPerformaInvoiceReceiptList_list_action,
    addAccountReceipt_list_action,
    updateAccountReceipt_list_action,
    accountReceipt_Details_action,
    generate_invoice_action,
    getReceiptNo_list_action, preview_receipt_action,
    download_no_due_action, download_tax_invoice_action, download_exitPass_action, generate_nodue_action, update_exit_pass_action, generate_taxInvoice_action, getSendMailReceiptDetailsUrl_action, send_tax_invoice_action
  })(AccountReceiptsAU)
);
